export default {
  total: "Totale",
  paid: "Pagato",
  unpaid: "Non pagato",
  editor: "Editore",
  viewer: "Visitatore",
  view: "Visualizza",
  save: "Salva",
  cancel: "Annulla",
  delete: "Elimina",
  edit: "Modifica",
  add: "Aggiungi",
  close: "Chiudi",
  confirm: "Conferma",
  yes: "Sì",
  no: "No",
  loading: "Caricamento...",
  error: "Errore",
  success: "Successo",
  warning: "Attenzione",
  info: "Informazione",
  search: "Cerca",
  filter: "Filtra",
  sort: "Ordina",
  export: "Esporta",
  import: "Importa",
  download: "Scarica",
  upload: "Carica",
  print: "Stampa",
  share: "Condividi",
  copy: "Copia",
  paste: "Incolla",
  cut: "Taglia",
  undo: "Annulla",
  redo: "Ripeti",
  refresh: "Aggiorna",
  back: "Indietro",
  next: "Avanti",
  previous: "Precedente",
  first: "Primo",
  last: "Ultimo",
  all: "Tutti",
  none: "Nessuno",
  select: "Seleziona",
  deselect: "Deseleziona",
  clear: "Pulisci",
  reset: "Reimposta",
  apply: "Applica",
  submit: "Invia",
  send: "Invia",
  receive: "Ricevi",
  create: "Crea",
  update: "Aggiorna",
  remove: "Rimuovi",
  duplicate: "Duplica",
  move: "Sposta",
  details: "Dettagli",
  actions: {
    _self: "Azioni",
    add: "Aggiungi",
    addLong: "Aggiungi nuovo elemento",
    importGuests: "Importa ospiti",
    share: "Condividi",
    useExample: "Usa esempio",
    addEvent: "Aggiungi evento",
    addExamples: "Aggiungi esempi",
    addingExamples: "Aggiunta esempi...",
    edit: "Modifica",
    delete: "Elimina",
    cancel: "Annulla",
    save: "Salva"
  },
  noResults: "Nessun risultato trovato",
  pagination: {
    showing: "Visualizzati {{from}} a {{to}} di {{total}} elementi"
  },
  time: "Ora",
  title: "Titolo",
  category: "Categoria",
  description: "Descrizione",
  continue: "Continua",
  required: "Obbligatorio",
  optional: "Opzionale",
  or: "o",
  and: "e",
  selectAll: "Seleziona tutto",
  deselectAll: "Deseleziona tutto",
  content: "Contenuto",
  today: "Oggi",
  yesterday: "Ieri",
  saving: "Salvataggio...",
  viewAll: "Vedi tutto",
  more: "Altro",
  less: "Meno",
  show: "Mostra",
  hide: "Nascondi",
  errors: {
    generic: "Si è verificato un errore",
    network: "Errore di rete",
    unauthorized: "Accesso non autorizzato",
    notFound: "Risorsa non trovata",
    serverError: "Errore del server",
    tryAgain: "Riprova",
    goBack: "Indietro",
    reload: "Ricarica pagina",
    submit: "Errore nell'invio",
    loadGuests: "Errore nel caricamento degli ospiti",
    updateGuest: "Errore nell'aggiornamento dell'ospite",
    socialLoginFailed: "Accesso social fallito",
    userOrWeddingNotFound: "Utente o matrimonio non trovato",
    googleSignIn: "Errore di accesso con Google",
    loadVendors: "Errore nel caricamento dei fornitori",
    addVendor: "Errore nell'aggiunta del fornitore",
    updateVendor: "Errore nell'aggiornamento del fornitore",
    deleteVendor: "Errore nell'eliminazione del fornitore",
    saveSeatingPlan: "Errore nel salvataggio del piano dei tavoli",
    generateSeatingPlan: "Errore nella generazione del piano dei tavoli"
  },
  disconnect: "Disconnetti",
  sending: "Invio in corso...",
  verified: "Verificato",
  importGuests: "Importa ospiti",
  status: {
    to_contact: "Da Contattare",
    contacted: "Contattato",
    meeting_scheduled: "Incontro Programmato",
    quote_received: "Preventivo Ricevuto",
    hired: "Assunto",
    deposit_paid: "Acconto Pagato",
    completed: "Completato",
    cancelled: "Annullato",
    pending: "In Attesa",
    confirmed: "Confermato",
    declined: "Rifiutato",
    accepted: "Accettato",
    inProgress: "In corso",
    paid: "Pagato",
    unpaid: "Non pagato",
    overdue: "In ritardo",
    scheduled: "Programmato",
    done: "Fatto",
    todo: "Da fare",
    researching: "Ricerca"
  },
  categories: {
    other: "Altro",
    venue: "Luogo",
    catering: "Catering",
    photography: "Fotografia",
    music: "Musica",
    decoration: "Decorazione",
    flowers: "Fiori",
    attire: "Abbigliamento",
    jewelry: "Gioielli",
    transport: "Trasporto",
    lodging: "Alloggio",
    ceremony: "Cerimonia",
    reception: "Ricevimento",
    videography: "Videografia",
    florist: "Fiorista",
    cake: "Torta",
    dress: "Abito",
    suit: "Abito sposo",
    hair_makeup: "Trucco e Parrucco",
    beauty: "Bellezza"
  },
  pwa: {
    offlineReady: "App pronta per l'uso offline",
    newContent: "Nuovo contenuto disponibile, clicca per aggiornare.",
    reload: "Ricarica"
  },
  validation: {
    required: {
      firstName: "Il nome è obbligatorio",
      lastName: "Il cognome è obbligatorio",
      email: "L'email è obbligatoria"
    },
    invalid: {
      email: "L'email non è valida"
    }
  },
  empty: {
    title: "Nessun dato",
    description: "Niente da visualizzare per ora."
  },
  columns: {
    name: "Nome",
    status: "Stato",
    category: "Categoria",
    actions: "Azioni",
    plusOne: "+1",
    children: "Bambini"
  },
  confirmDialog: {
    delete: "Sei sicuro di voler eliminare questo elemento?",
    budgetRemoval: {
      title: "Elimina budget",
      message: "Vuoi davvero eliminare questo budget?",
      confirm: "Elimina",
      cancel: "Annulla"
    }
  },
  deleteConfirmation: {
    title: "Elimina",
    description: "Questa azione è irreversibile.",
    confirmTitle: "Conferma eliminazione",
    confirmDescription: "Sei sicuro di voler eliminare questo elemento?",
    confirmButton: "Elimina"
  },
  sortOptions: {
    title: "Ordina per"
  },
  sharing: {
    title: "Condivisione",
    share: "Condividi",
    accessLevel: "Livello di Accesso",
    accessCode: "Codice di Accesso",
    readOnly: "Sola Lettura",
    edit: "Modifica",
    copy: "Copia Link",
    copied: "Link copiato!",
    emailPlaceholder: "esempio@email.com",
    namePlaceholder: "Nome del Destinatario",
    messagePlaceholder: "Aggiungi un messaggio personale...",
    recipientEmail: "Email del Destinatario",
    recipientName: "Nome del Destinatario",
    message: "Messaggio",
    defaultMessage: "Ti invito a collaborare al mio matrimonio!",
    invitationCreated: "Invito creato con successo",
    success: "Condiviso con successo"
  },
  upgrade: "Migliora",
  currentEvent: "Evento attuale"
};
